import { Injectable } from '@angular/core';

@Injectable()
export class AppService {
  static isSitePath(urlSplit: string[]): boolean {
    return urlSplit.indexOf('site') !== -1 && urlSplit.indexOf('create') === -1;
  }

  static siteCreatePath(urlSplit: string[]): boolean {
    return urlSplit.indexOf('create-from-template') !== -1;
  }

  static templatePath(urlSplit: string[]): boolean {
    return urlSplit.indexOf('template') !== -1 && urlSplit.indexOf('create') === -1;
  }

  static manageTemplatePath(urlSplit: string[]): boolean {
    return urlSplit.indexOf('templates') !== -1 && urlSplit.indexOf('manage') !== -1;
  }

  static exceptionPath(urlSplit: string[]): boolean {
    // do not display tabs during job polling
    return urlSplit.indexOf('job') !== -1;
  }
}
